import React from 'react';
import Barcode from 'react-barcode'

export default function MethodBarcode({ url }) {
	return <Barcode displayValue={false} value={url} />
}